<template>
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.9999 0.899902C7.33127 0.899902 7.5999 1.16853 7.5999 1.4999V6.3999H12.4999C12.8313 6.3999 13.0999 6.66853 13.0999 6.9999C13.0999 7.33127 12.8313 7.5999 12.4999 7.5999H7.5999V12.4999C7.5999 12.8313 7.33127 13.0999 6.9999 13.0999C6.66853 13.0999 6.3999 12.8313 6.3999 12.4999V7.5999H1.4999C1.16853 7.5999 0.899902 7.33127 0.899902 6.9999C0.899902 6.66853 1.16853 6.3999 1.4999 6.3999H6.3999V1.4999C6.3999 1.16853 6.66853 0.899902 6.9999 0.899902Z"
    fill="currentColor" />
</template>
